import { render, staticRenderFns } from "./ReceivingInf.vue?vue&type=template&id=6cc1fd0a&scoped=true&"
import script from "./ReceivingInf.vue?vue&type=script&lang=js&"
export * from "./ReceivingInf.vue?vue&type=script&lang=js&"
import style0 from "./ReceivingInf.vue?vue&type=style&index=0&id=6cc1fd0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc1fd0a",
  null
  
)

export default component.exports